export enum ControlType {
	Zoom = 0,
	FullScreen,
	Locate,
	LayerList,
	CoordinateConversion,
	DistanceMeasurement2D,
	AreaMeasurement2D,
	BasemapGallery,
	Print,
	ToggleButton,
	EditGeometry,
	Sketch,
	Search,
}
